import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

import type PlannedBreakForm from './forms/PlannedBreakForm'
import { Shift } from './types'

export interface PlannedBreakParams {
  id: number | undefined
  startAt: string | undefined
  endAt: string | undefined
  duration: number
  breakType: string
  breakConfigurationId: number
  shiftId: number
}

const buildDates = (form: PlannedBreakForm, shift: Shift) => {
  const startTime = moment(form.get('start_at').value, 'HH:mm')
  const endTime = moment(form.get('end_at').value, 'HH:mm')

  if (!startTime.isValid() || !endTime.isValid()) return {}

  const startAt = shift.startAtWithTZ.clone().hour(startTime.hour()).minute(startTime.minute())
  const endAt = shift.startAtWithTZ.clone().hour(endTime.hour()).minute(endTime.minute())
  const isOverMidNight = endTime.isBefore(startTime) // 10pm - 1am
  const isWithinNight = startAt.isBefore(shift.startAtWithTZ) && startAt.isBefore(endAt) // 1am - 2am

  if (isWithinNight) {
    startAt.add(1, 'day')
  }

  if (isOverMidNight || isWithinNight) {
    endAt.add(1, 'day')
  }

  return {
    startAt: dateToString(startAt, 'backend_datetime'),
    endAt: dateToString(endAt, 'backend_datetime'),
  }
}

const buildAddPlannedBreaksParameters = (
  plannedBreakForms: PlannedBreakForm[],
  shifts: Shift[]
): PlannedBreakParams[] => {
  return shifts.flatMap((shift: Shift) => {
    return plannedBreakForms.map((form) => {
      const { startAt, endAt } = buildDates(form, shift)

      return {
        // On create, the id will be zero, so we need to pass undefined
        id: +form.get('id').value || undefined,
        startAt,
        endAt,
        duration: +form.get('duration').value,
        breakType: form.get('break_type').value,
        breakConfigurationId: +form.get('break_configuration.id').value,
        shiftId: shift.id,
      }
    })
  })
}

export default buildAddPlannedBreaksParameters
